import { Spinner } from 'reactstrap';
import './styles.scss';

export const OverlayLoading = () => (
  <div id="overlay">
    <Spinner style={{ width: '5rem', height: '5rem' }} color="primary" />
  </div>
);
